// import header from './components/header';
import search from './components/search';
import tab from './components/tab';
import accordion from './components/accordion';
import slider from './components/slider';
import modal from './components/modal';
import gallery from './components/gallery';
import dealerLocator from './components/dealer-locator';
import form from './components/form';
import print from './components/print';
import filter from './components/filter';
// import tyreSizeGuide from './components/tyre-size-guide';
import drawer from './components/drawer';

// header();
search();
tab();
accordion();
slider();
modal();
gallery();
dealerLocator();
form();
print();
filter();
// tyreSizeGuide();
drawer();
